// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/common/footer.css
// module id = 782
// module chunks = 1